import React, { useContext } from "react";
import { Cases, DELETE_CONFIRM } from "../../../constant";
import { Col, Container, Input, Label, Row } from "reactstrap";
import { Zoom, toast } from "react-toastify";
import { splitPathWeb } from "../../../apiConstants";
import { delete_Image_Permanent } from "../../../apis/SliderApi/SliderApi";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import Dividers from "../../../common/divider";
import { OpenModalCommonFunc } from "../../../utils";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import { UploadCloud } from "react-feather";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import PaymentContext from "../../../context/PaymentContext/PaymentContext";

const PaymentPopup = (props) => {
  const { imageUpload, simpleValidator } = props;
  const { setFormDataPayment, formDataPayment, isEdit } =
    useContext(PaymentContext);
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { setLoaderShow } = useContext(LoaderContext);

  /**
   * input value change
   * @param {event} e
   */
  const changeFormValue = (e) => {
    const { name, value } = e.target;
    setFormDataPayment((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  /**
   * image reupload
   */
  const reupload = () => {
    setFormDataPayment((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };

  /**
   * image delete permanently
   */
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: formDataPayment.image
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER}/`)
            .pop(),
        };
        const { data } = await delete_Image_Permanent(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            position: "top-center",
          });
          setFormDataPayment({ ...formDataPayment, image: "" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };
  return (
    <>
      <Container className="mb-5">
        <Row>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-around",
              marginBottom: "3rem",
            }}
          >
            <div className="mt-4 d-flex flex-column justify-content-center ">
              <h6>{isEdit ? "Edit" : "Add New"}</h6>
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">{"Title *"}</Label>
                  <Input
                    className="form-control"
                    name="title"
                    type="text"
                    placeholder="Title *"
                    value={formDataPayment.title}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                  <p style={{ color: "red" }}>
                    {simpleValidator.current.message(
                      "title",
                      formDataPayment.title,
                      "required"
                    )}
                  </p>
                </Col>
              </Row>
              <Dividers divide="IMAGE" />
              <p className="mb-4">
                File type required JPG, PNG (512px X 512px)
              </p>
              <Row>
                <Col md="6 mb-3">
                  <div
                    className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      onClick={() =>
                        OpenModalCommonFunc(
                          Cases.PRODUCT_UPLOAD,
                          setAllPopupState
                        )
                      }
                    >
                      <UploadCloud />
                    </span>
                    {formDataPayment?.image && (
                      <img
                        src={
                          formDataPayment?.image ? formDataPayment?.image : ""
                        }
                        alt=""
                        style={{
                          width: "80%",
                          height: "98%",
                          objectFit: "contain",
                          position: "absolute",
                        }}
                        onClick={() =>
                          OpenModalCommonFunc(
                            Cases.PRODUCT_UPLOAD,
                            setAllPopupState
                          )
                        }
                      />
                    )}
                    {formDataPayment.image && (
                      <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="close"
                        style={{
                          color: "red",
                          position: "absolute",
                          top: "-22px",
                          left: "1px",
                        }}
                        onClick={() => deleteImagePermanent()}
                      >
                        <Close
                          style={{ fontSize: "25px", fontWeight: "bold" }}
                        />
                      </IconButton>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Row>
        <ProductImageUploadPopup
          allPopupState={allPopupState}
          setAllPopupState={setAllPopupState}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          image={formDataPayment.image}
          setImage={setFormDataPayment}
          imageUpload={imageUpload}
          isEdit={isEdit}
          reupload={reupload}
          aspect={1 / 1}
        />
      </Container>
    </>
  );
};

export default PaymentPopup;
